import React, { useState, useMemo, useCallback } from 'react';
import {
  Filters,
  Checkbox,
  Combobox,
  Listbox,
  Icon,
  Stack
} from '@shopify/polaris';
import {
  SearchMinor
} from '@shopify/polaris-icons';

function disambiguateLabel(key, value) {
  switch (key) {
    case 'taggedWith3':
      return `Tagged with: ${value.join(", ")}`;
    default:
      return value;
  }
}

function isEmpty(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  } else {
    return value === '' || value == null;
  }
}

function FilterPane(props) {

  const { query, onQueryChange } = props;
  const taggedWith = props.query.taggedWith;
  const queryValue = props.query.queryValue;
  const skipArchived = props.query.skipArchived;
  const noTags = props.query.noTags;
  const [tagSearchValue, setTagSearchValue] = useState("");
  const allTagOptions = useMemo(
    () => props.allTags.map(_ => {
      return {
        value: _, label: _,
      }
    }),
    [props.allTags],
  );

  let tagOptions = [];

  if (tagSearchValue === '') {
    tagOptions = allTagOptions;
  }
  else {
    const filterRegex = new RegExp(tagSearchValue, 'i');
    const resultOptions = allTagOptions.filter((option) =>
      option.label.match(filterRegex),
    );
    tagOptions = resultOptions;
  }

  const handleTaggedWithChange = useCallback((newTaggedWith) => {
    onQueryChange(
      {
        ...query,
        taggedWith: newTaggedWith,
      }
    );
  }, [query, onQueryChange]);

  const updateSelection = useCallback(
    (selected) => {
      if (taggedWith.includes(selected)) {
        handleTaggedWithChange(
          taggedWith.filter((option) => option !== selected),
        );
      } else {
        handleTaggedWithChange([...taggedWith, selected]);
      }

      setTagSearchValue('');
    },
    [taggedWith, handleTaggedWithChange],
  );

  const handleQueryValueChange = function (value) {
    onQueryChange(
      {
        ...query,
        queryValue: value,
      }
    );
  };
  const handleQueryValueRemove = function () {
    onQueryChange(
      {
        ...query,
        queryValue: "",
      }
    );
  };
  const handleTaggedWithRemove = function () {
    onQueryChange(
      {
        ...query,
        taggedWith: [],
      }
    );
  };

  const handleOnSkipArchivedChange = function (value) {
    onQueryChange(
      {
        ...query,
        skipArchived: value,
      }
    );
  };

  const handleOnNoTagsChange = function (value) {
    onQueryChange(
      {
        ...query,
        noTags: value,
      }
    );
  };

  const handleClearAll = function () {
    onQueryChange(
      {
        taggedWith: [],
        queryValue: null,
        skipArchived: false
      }
    );
  };

  const optionsMarkup =
    tagOptions.length > 0
      ? tagOptions.map((option) => {
        const { label, value } = option;

        return (
          <Listbox.Option
            key={`${value}`}
            value={value}
            selected={taggedWith.includes(value)}
            accessibilityLabel={label}
          >
            {label}
          </Listbox.Option>
        );
      })
      : null;

  var taggedWithFilterControl = (<Combobox
    allowMultiple
    activator={
      <Combobox.TextField
        prefix={<Icon source={SearchMinor} />}
        onChange={(value) => { setTagSearchValue(value) }}
        label="Search tags"
        labelHidden
        value={tagSearchValue}
        placeholder="Search tags"
      />
    }
  >
    {
      optionsMarkup ? (
        <Listbox onSelect={updateSelection} > {optionsMarkup}</Listbox>
      ) : null}
  </Combobox >)

  const filters = [
    {
      key: 'taggedWith3',
      label: 'Tagged with',
      filter: (
        // <TextField
        //   label="Tagged with"
        //   value={taggedWith}
        //   // onChange={handleTaggedWithChange}
        //   autoComplete="off"
        //   labelHidden
        // />
        taggedWithFilterControl
      ),
      shortcut: true,
    }
  ];

  const appliedFilters = [];

  if (!isEmpty(taggedWith)) {
    appliedFilters.push({
      key: 'taggedWith3',
      label: disambiguateLabel('taggedWith3', taggedWith),
      onRemove: handleTaggedWithRemove,
    },);
  }

  const filterControl = (
    <Filters
      queryPlaceholder="Search for products by title"
      queryValue={queryValue}
      filters={filters}
      appliedFilters={appliedFilters}
      onQueryChange={handleQueryValueChange}
      onQueryClear={handleQueryValueRemove}
      onClearAll={handleClearAll}
    >
    </Filters>
  );

  return (<React.Fragment>
    <div>
      <Stack>
        <Checkbox
          label="Skip Archived Products"
          checked={skipArchived}
          onChange={handleOnSkipArchivedChange}
        />
        <Checkbox
          label="Products With No Tags"
          checked={noTags}
          onChange={handleOnNoTagsChange}
        />
      </Stack>

    </div>
    {filterControl}
  </React.Fragment>
  );

}

export default FilterPane;